<script setup lang="ts">

import {useFavoriteStore} from "../../stores/favorite";
import {type HTMLAttributes, ref, type Ref} from "vue";
import NoAccountModal from "./NoAccountModal.vue";
import {type ProductResponse} from "../../../responses/ProductResponse";

interface Props {
    product: ProductResponse
    iconClass?: HTMLAttributes['class']
}
const props = defineProps<Props>();

const favoriteStore = useFavoriteStore();
const loggedIn: Ref<boolean> = ref(window.logged_in ?? false);
const isFavorite: Ref<boolean> = ref(props.product.is_favorite);
const noAccountModal: Ref<boolean> = ref(false);
const toggleFavorite = () => {
    if(!loggedIn.value) {
        noAccountModal.value = true;
        return;
    }
    favoriteStore.toggleFavorite(props.product.id).then(() => {
        isFavorite.value = !isFavorite.value;
    }).catch(console.error);

}
</script>

<template>
    <button :class="iconClass" @click.prevent="toggleFavorite">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" :fill="isFavorite ? '' : 'none'"
             stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
             class="lucide lucide-heart-icon lucide-heart">
            <path
                d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
        </svg>
    </button>

    <NoAccountModal v-if="noAccountModal" @close="noAccountModal = false"></NoAccountModal>
</template>
